// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from '/root/workspace/__flow_work/__flow_builds/446d3e98-a298-48f3-8169-d55437795ded/workspace/sunflowerbrainadmin_RSua/node_modules/.pnpm/@umijs+renderer-react@4.6.29_nnrd3gsncyragczmpvfhocinkq/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
